import { styled } from '@mui/material';

export const Grid = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '1fr 1fr',
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

interface Props {
  fullRow: boolean;
}

export const GridItem = styled('div')<Props>(({ fullRow }) => ({
  gridColumn: fullRow ? '1 / -1' : '',
  minWidth: 0,
}));
